__turbopack_context__.v({
  "contentStyles": "entityTileItem-module-scss-module__06450a__contentStyles",
  "copyright": "entityTileItem-module-scss-module__06450a__copyright",
  "gradientBackground": "entityTileItem-module-scss-module__06450a__gradientBackground",
  "hoverStyles": "entityTileItem-module-scss-module__06450a__hoverStyles",
  "imageInCardStyles": "entityTileItem-module-scss-module__06450a__imageInCardStyles",
  "linkStyles": "entityTileItem-module-scss-module__06450a__linkStyles",
  "mainWrapper": "entityTileItem-module-scss-module__06450a__mainWrapper",
  "noLinkContentStyles": "entityTileItem-module-scss-module__06450a__noLinkContentStyles",
});
